import GrupoContabilService from "../../services/resource/GrupoContabilService";
import CrudTemplate from "../crudTemplate";

export default function GrupoContabilCrud() {
    const service = new GrupoContabilService();

    const formFields = [
        { name: "descricao", label: "Descrição", type: "input", placeholder: "Ex: TI", colSpan: 1 }
    ];

    const tableColumns = [
        { key: "id", label: "Código", bold: true },
        { key: "descricao", label: "Descrição" }
    ];

    return <CrudTemplate
        title="Gerenciar Grupos Contabéis"
        formFields={formFields}
        tableColumns={tableColumns}
        service={service}
    />;
}
